// @flow strict
// Group and Button are required together, no need for separate story books.
// eslint-disable-next-line ta-code-conventions/has-matching-storydoc
import * as React from 'react';

/**
 * Context holding the group name of this RadioGroup or undefined if the component is not currently part of a RadioGroup.
 */
export const RadioGroupContext = React.createContext<?string>(undefined);

type Props = {|
  /** The unique name of this radio group. */
  name: string,
  /** The ID of the element that displays the name/text for this radio group */
  labelId: string,
  /** Children to render. These should typically be only RadioButton components. */
  children?: React.Node,
|};

/**
 * A component build for aria's role=radiogroup.  This standardizes a11y for radio buttons.
 */
const RadioGroup = ({ name, labelId, children }: Props) => (
  <div role="radiogroup" aria-labelledby={labelId}>
    <RadioGroupContext.Provider value={name}>{children}</RadioGroupContext.Provider>
  </div>
);

export default RadioGroup;
